import { WORKFLOW_VARIABLE_LABELS } from "../workflowVariables.constants";

/** @typedef {{ text: string, operator: string }} FilterOperatorOption */

/** @type {FilterOperatorOption[]} */
export const MULTI_DIM_TEXT_FILTER_OPERATORS = [
  { text: "Contains", operator: "contains" },
  { text: "Does not contain", operator: "doesnotcontain" },
  { text: "Is equal to", operator: "eq" },
  { text: "Is not equal to", operator: "neq" },
];

/** @type {FilterOperatorOption[]} */
export const MULTI_DIM_NUMERIC_DATE_FILTER_OPERATORS = [
  { text: "Is equal to", operator: "eq" },
  { text: "Is not equal to", operator: "neq" },
  { text: "Is greater than or equal to", operator: "gte" },
  { text: "Is greater than", operator: "gt" },
  { text: "Is less than or equal to", operator: "lte" },
  { text: "Is less than", operator: "lt" },
];

/** @type {{ value: "and"|"or", label: string }[]} */
export const MULTI_DIM_FILTER_LOGIC_OPTIONS = [
  { value: "and", label: WORKFLOW_VARIABLE_LABELS.MULTI_DIMENSION_FILTER_LOGIC_AND },
  { value: "or", label: WORKFLOW_VARIABLE_LABELS.MULTI_DIMENSION_FILTER_LOGIC_OR },
];

/**
 * @param {"text"|"number"|"date"} type
 * @returns {FilterOperatorOption[]}
 */
export const getOperatorsForDimensionType = (type) => {
  if (type === "text") return MULTI_DIM_TEXT_FILTER_OPERATORS;
  return MULTI_DIM_NUMERIC_DATE_FILTER_OPERATORS;
};

/**
 * @param {"text"|"number"|"date"} type
 * @returns {{ logic: "and"|"or", filters: { operator: string, value: * }[] }}
 */
export const createDefaultCompositeFilter = (type) => {
  const ops = getOperatorsForDimensionType(type);
  const firstOp = ops[0]?.operator ?? "eq";
  if (type === "date") {
    return {
      logic: "and",
      filters: [
        { operator: firstOp, value: null },
        { operator: firstOp, value: null },
      ],
    };
  }
  if (type === "number") {
    return {
      logic: "and",
      filters: [
        { operator: firstOp, value: null },
        { operator: firstOp, value: null },
      ],
    };
  }
  return {
    logic: "and",
    filters: [
      { operator: firstOp, value: "" },
      { operator: firstOp, value: "" },
    ],
  };
};
